import "./style.scss";
import { Link } from "react-router-dom";
import { Phone } from "@/src/svg/Phone";
import { Mail } from "@/src/svg/Mail";
import Target from "@/src/svg/Target";

const ContactMob = () => {
  return (
    <div className="container contact-mob padding-top">
      <div className="contact-mob-title">
        <p>Хотите узнать больше? Напишите нам!</p>
      </div>
      <div className="contact-mob-subtitle">
        <p>
          <span>Мальтийская школа медицины и бизнеса</span> будет рада ответить на ваши вопросы.
        </p>
      </div>
      <div className="contact-mob-content">
        <Link to={"/"} className="contact-mob-button">
          <Phone />
          <p>Whatsapp: +998 90 006 44 43</p>
        </Link>
        <Link to={"/"} className="contact-mob-button">
          <Phone />
          <p>Whatsapp: +998 95 794 44 42</p>
        </Link>
        <a href="mailto:info@msmbmalta.com" className="contact-mob-button mail">
          <Mail />
          <p>електронная почта: info@msmbmalta.com</p>
        </a>
        <Link to={"/apply-online"} className="btn-default">
          Ваше сообщение
        </Link>
        <Link to={"/"} className="contact-mob-button address">
          <Target />
          <p>Адрес: 151 triq Edgar Bernard, Gzira, Malta. GZR 1707</p>
        </Link>
      </div>
    </div>
  );
};

export default ContactMob;
